import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LotSignFlowService {
  private data$ = new BehaviorSubject<LotSignFlowData>({});

  constructor() {
  }

  connect() {
    return this.data$.asObservable();
  }

  setData(reqData: LotSignFlowData) {
    this.data$.next(reqData);
  }

  clearData() {
    this.data$.next({});
  }

  get currentData(): LotSignFlowData {
    return this.data$.getValue();
  }
}

export class LotSignFlowData {
  contractIds?: string[];
  menuContract?: string;
}
